export const HOME_FAQS = [
  {
    q: "What is the price of flats in Adani Shantigram, Ahmedabad?",
    a: "2 BHK flats in Shantigram start around ₹60–90 lakh, 3 BHK homes typically range ₹1–2 crore, and 4 BHK and larger residences start from around ₹2 crore, with penthouses and villas priced higher. Prices vary by tower, floor and view — call us for today's availability and best quotes.",
  },
  {
    q: "Are ready-to-move flats available in Adani Shantigram?",
    a: "Yes. Ready-to-move options include The Storeys (4/5 BHK), Paarijat (4 BHK), La Marina (4 & 5 BHK penthouses), Water Lily (5 BHK duplex penthouses), Aster NEO (2 BHK smart homes) and The West Park villas.",
  },
  {
    q: "Do you have resale flats in Adani Shantigram?",
    a: "Yes — we deal in verified resale flats and villas across Shantigram: 2 to 5 BHK owner-listed units in Aster, Paarijat, The Meadows, La Marina and more, with clear titles, genuine pricing and end-to-end documentation support.",
  },
  {
    q: "Which BHK configurations are available in Shantigram?",
    a: "The township offers 1 to 6 BHK apartments, duplexes, penthouses and independent villas across clusters like Aster, Elysium, Embrace, Ambrosia, Belrosa, Skyline, The Storeys, The North Park and The West Park.",
  },
  {
    q: "Where exactly is Adani Shantigram located?",
    a: "At Vaishnodevi Circle on SG Highway, Ahmedabad — minutes from SP Ring Road, around 25 minutes from Sardar Vallabhbhai Patel International Airport, and right on the Ahmedabad–Gandhinagar corridor.",
  },
  {
    q: "Is Adani Shantigram a good investment?",
    a: "Shantigram is Gujarat's largest integrated township — 600 acres with a 9-hole golf course, 7-acre lake, schools, sports academy and retail inside the gates. The SG Highway corridor has shown steady price appreciation with strong rental demand from professionals working in Ahmedabad and GIFT City.",
  },
  {
    q: "How do I book a site visit for Shantigram projects?",
    a: "Call or WhatsApp us on +91 90160 75761, or submit the enquiry form on this page. Our Shantigram specialist will arrange a guided site visit with floor plans, pricing and payment schedules for any cluster you're considering.",
  },
  {
    q: "Can I find flats for rent in Adani Shantigram?",
    a: "Yes — we handle rentals across the township too. Indicative rents: 2 BHK around ₹25,000–40,000 per month, 3 BHK around ₹35,000–55,000, and 4 BHK or villas ₹60,000 and above. Owners can also list their units with us.",
  },
];
